<template>
  <div>
    <div v-if="$store.state.user.clientID" :key="$root.time">
      <h1 class="main-heading">Goods & Services</h1>
      <SectionNavigator
        :sections="$root.goodsAndServices.sections"
        :schemas="$root.goodsAndServices.schemas"
      />
      <router-view />
    </div>
  </div>
</template>

<script>
import SectionNavigator from '../SectionNavigator'

// import routes from '../../router/index'
export default {
  name: 'category-goods-and-services',
  props: { sections: String, schemas: Array },
  components: {
    SectionNavigator
  }
}
</script>
